import getEmailData from 'global/emailAlreadyRegistered/emailAlreadyRegisteredModels';
import { Events } from '../constants';

export default class EmailAlreadyRegistered {
	constructor() {
		this.emailInput = document.querySelector(
			'[data-check-email-already-registered]',
		);
		this.errorHtml = document.getElementById('emailAlreadyRegisteredError');
		if (this.emailInput && this.errorHtml) {
			this.activeClass = 'form-inline-row__ajax-errors--is-active';
			this.invaldInputClass = 'is-invalid-ajax';
			this.isEmailAlreadyRegistered = false;

			this.handleEmail = this.handleEmail.bind(this);
			this.isEmailRegistered = this.isEmailRegistered.bind(this);
			this.handleFormSubmit = this.handleFormSubmit.bind(this);
			this.displayValidation = this.displayValidation.bind(this);
			this.aboutYouPageType = window.od.aboutYouFormPageType || 'checkout';

			this.form = this.emailInput.closest('form');

			window.od.events.subscribe(Events.VALIDATION, this.subscribe.bind(this));
			this.form.addEventListener('submit', this.handleFormSubmit);
		}
	}

	subscribe(data) {
		let request;
		if (data.payload.field === this.emailInput && data.payload.isValid) {
			request = this.handleEmail();
		} else if (data.payload.field === this.emailInput) {
			this.isEmailAlreadyRegistered = false;
			this.displayValidation();
		}

		return request;
	}

	handleEmail() {
		return this.isEmailRegistered(this.emailInput.value)
			.then(isRegistered => {
				this.isEmailAlreadyRegistered = isRegistered;
			})
			.then(this.displayValidation)
			.catch(() => null);
	}

	isEmailRegistered(email) {
		return new Promise((resolve, reject) =>
			getEmailData(email, this.aboutYouPageType).then(({ data, status }) => {
				if (status === 200) {
					if (data.status === 'FAIL') {
						// Status of FAIL means email is already registered
						resolve(true);
					}
					resolve(false);
				}
				reject();
			}),
		);
	}

	displayValidation() {
		if (this.isEmailAlreadyRegistered) {
			this.errorHtml.classList.add(this.activeClass);
			this.emailInput.classList.add(this.invaldInputClass);
		} else {
			this.errorHtml.classList.remove(this.activeClass);
			this.emailInput.classList.remove(this.invaldInputClass);
		}
	}

	handleFormSubmit(e) {
		if (this.isEmailAlreadyRegistered) {
			e.preventDefault();
		}
	}
}
